// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e26c9b53","455":"549a7ee0"}[chunkId] + ".chunk.js";
};